export default __webpack_public_path__ + "static/media/social-icon-instagram.dc8c5f03.svg";